import { useState } from "react";

import { DCOReviewContext } from "./DCOReviewContext";
import { AllSetStep } from "./Steps/AllSetStep";
import { DisputeConfirmStep } from "./Steps/DisputeConfirmStep";
import { DisputeResultsStep } from "./Steps/DisputeResultsStep";
import { ReviewDecisionStep } from "./Steps/ReviewDecisionStep";
import { ReviewLandingStep } from "./Steps/ReviewLandingStep";

export function DCOReviewDecisionPage() {
  const [currentStep, setCurrentStep] = useState(0);
  const [dispute, setDispute] = useState(false);

  const steps = [
    <ReviewLandingStep key="ReviewLandingStep" />,
    <ReviewDecisionStep key="ReviewDecisionStep" />,
    <DisputeConfirmStep key="DisputeConfirmStep" />,
    <DisputeResultsStep key="DisputeResultsStep" />,
    <AllSetStep key="AllSetStep" />,
  ];

  const handleNext = () => {
    setCurrentStep((curr) => curr + 1);
  };

  const handlePrev = () => {
    if (currentStep === 4 && !dispute) {
      setCurrentStep(1);
    } else {
      setCurrentStep((curr) => curr - 1);
    }
  };

  const handleGotoStep = (step: number) => {
    setCurrentStep(step);
  };

  return (
    <DCOReviewContext.Provider
      value={{
        dispute,
        setDispute,
        currentStep,
        goToNextStep: handleNext,
        goToPrevStep: handlePrev,
        goToStep: handleGotoStep,
      }}
    >
      {steps[currentStep]}
    </DCOReviewContext.Provider>
  );
}
